import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { CookieService } from 'ngx-cookie-service'
import { environment } from '../../../environments/environment'
import { PkwDatastore } from '../../pkw-data/pkw-datastore'

@Injectable()
export class SchemaService {
    constructor(
        private httpClient: HttpClient,
        private cookieService: CookieService,
        private pkwDatastore: PkwDatastore
    ) {}

    evolve() {
        const jwt = this.cookieService.get('jwt')
        const headers = { Authorization: `Bearer ${jwt}` }
        const url = `${environment.collectJsonApiBaseUrl}/schemas/evolve`

        return this.httpClient.get(url, { headers })
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/schema.service.ts